import React from "react";
import { Field } from "react-final-form";
import { SelectAdapter } from "@soqs/common";
const EntityTypeSelectComponent = (props) => {
  let { taxoptions, disabled, optionsloading, ...rest } = props;

  if (optionsloading === undefined) {
    optionsloading = false;
  }

  const required = (value) => (value ? undefined : "Required");

  return (
    <Field
      required
      fullWidth
      label="Entity Type"
      name="entitytype"
      validate={required}
      component={SelectAdapter}
      options={taxoptions}
      loading={optionsloading}
      disabled={disabled}
      subscription={{ touched: true, value: true, error: true }}
      {...rest}
    />
  );
};

export default EntityTypeSelectComponent;
